export const shellyConfig = {
  common: {
    saving: "جارٍ الحفظ...",
    online: "متصل",
    offline: "غير متصل",
  },

  step1: {
    title: "إعداد Shelly",
    subtitle:
      "اربط حساب Shelly Cloud للتحكم في المرحّلات (الأقفال الكهربائية، البوابات، وغيرها).",
    connected: "الحساب متصل",
    notConnected: "غير متصل",
    credentialsInfo:
      "ستجد بيانات الاعتماد في تطبيق Shelly: <b>إعدادات المستخدم ← مفتاح تفويض السحابة</b>. هناك سترى <b>Server URI</b> ويمكنك إنشاء <b>Auth Key</b> الخاص بك.",
    serverUriPlaceholder: "مثال: shelly-103-eu.shelly.cloud",
    serverUriHelp: "خادم السحابة المخصّص لحساب Shelly الخاص بك.",
    authKeyPlaceholderSaved: "•••••••• (محفوظ بالفعل، تغييره اختياري)",
    authKeyPlaceholderNew: "الصق مفتاح تفويض السحابة",
    authKeyHelpSaved: "يمكنك تركه فارغًا إذا كان لديك مفتاح محفوظ بالفعل.",
    authKeyHelpNew:
      "يتيح هذا المفتاح التحكم في أجهزتك: احتفظ به بعناية.",
    testing: "جارٍ الاختبار...",
    testConnection: "اختبار الاتصال",
    saveCredentials: "حفظ بيانات الاعتماد",
  },

  step2: {
    title: "محدِّد الأجهزة لهذا العقار",
    subtitle:
      "اختر فقط مرحّلات Shelly الخاصة بـ<b>هذا العقار</b>. بعد ذلك، سترى في نظام PMS المحدَّدة فقط.",
    selectedCount: "{count} محدد",
    hintCredentials:
      "أدخل Server URI و Auth Key ثم اضغط <b>اختبار الاتصال</b> لتحميل أجهزتك.",
    noDevices: "لم يتم العثور على أجهزة في حساب Shelly الخاص بك.",
    selectPlaceholder: "اختر الأجهزة…",
    devicesSelected: "{count} جهاز محدد",
    noneSelected: "لم يُحدَّد أي جهاز",
    channels: "{count} قناة",
    saveDevices: "حفظ أجهزة هذا العقار",
  },

  step3: {
    title: "التحكم والتعيين (PMS)",
    subtitle:
      "عيّن كل مرحّل إلى <b>الباب الرئيسي</b> أو <b>الوحدة</b> أو <b>البوابة</b> واضبط نبضة الفتح.",
    assignedCount: "{count} مُعيّن",
    noSavedDevices:
      "لا توجد لديك أجهزة محفوظة لهذا العقار بعد. استخدم <b>المحدِّد</b> بالأعلى ثم احفظ.",
    pulseInfo:
      "<b>فتح</b> يرسل نبضة إلى المرحّل (يعمل ثم يتوقّف تلقائيًا بعد الثواني المحددة): مثالي للأقفال الكهربائية والبوابات. لا يُنشئ Shelly رموز PIN.",
    open: "فتح",
    openTooltip: "فتح (نبضة)",
    turnOnTooltip: "تشغيل المرحّل",
    turnOffTooltip: "إيقاف المرحّل",
    refreshTooltip: "تحديث الحالة",
    assignment: "التعيين",
    assignNone: "غير مُعيّن",
    assignCommon: "الباب الرئيسي (مشترك)",
    assignUnit: "باب الشقة",
    assignGate: "بوابة / مرآب",
    hintNone: "لن يتم التحكم فيه من نظام PMS.",
    hintAssigned: "سيرتبط بهذا العقار للفتح عن بُعد.",
    unitLabel: "الوحدة / مكان الإقامة",
    selectUnit: "اختر وحدة",
    unitFallback: "الوحدة {id}",
    selectUnitHint: "اختر الوحدة التي يفتحها هذا المرحّل.",
    channelLabel: "قناة المرحّل",
    channelOption: "القناة {n}",
    channelHint: "القناة الموصولة بالقفل (أجهزة متعددة المرحّلات).",
    pulseLabel: "نبضة الفتح (بالثواني)",
    pulseHint: "المدة التي يبقى فيها المرحّل مشغَّلًا عند الفتح.",
    nameLabel: "الاسم (اختياري)",
    namePlaceholder: "مثال: الباب الرئيسي / شقة 101",
    nameHint: "الاسم الظاهر في نظام PMS لهذا الجهاز.",
    saveAssignment: "حفظ التعيين",
    tip:
      "نصيحة: عيّن كل مرحّل ثم اضغط <b>حفظ التعيين</b>. تُفعَّل أزرار التحكم بمجرد تعيين الجهاز.",
  },

  toast: {
    loadDevicesFailed: "تعذّر تحميل الأجهزة",
    loadDevicesError: "خطأ أثناء تحميل الأجهزة",
    missingCredentials: "يجب إدخال Server URI و Auth Key الخاص بـ Shelly.",
    connectionSuccess:
      "تم الاتصال بنجاح. تم العثور على {count} جهاز.",
    testError: "خطأ أثناء اختبار الاتصال",
    invalidAuthKey: "يجب إدخال Auth Key صالح (10 أحرف على الأقل).",
    missingServerUri: "يجب إدخال Server URI الخاص بحساب Shelly.",
    credentialsSaved: "تم حفظ بيانات الاعتماد بنجاح",
    credentialsError: "خطأ أثناء حفظ بيانات الاعتماد",
    credentialsSaveError: "خطأ أثناء حفظ بيانات الاعتماد: {error}",
    selectAtLeastOne:
      "يجب تحديد جهاز واحد على الأقل لهذا العقار.",
    devicesSaved: "تم حفظ الأجهزة لهذا العقار",
    devicesSaveFailed: "تعذّر حفظ الأجهزة",
    saveError: "خطأ أثناء الحفظ: {error}",
    selectUnitForApartment:
      "اختر الوحدة للمرحّلات المعيَّنة كـ'باب الشقة'.",
    assignmentFailed: "تعذّر حفظ التعيين",
    assignmentSaved: "تم حفظ التعيين بنجاح",
    assignmentSaveError: "خطأ أثناء حفظ التعيين: {error}",
    opOpen: "تم إرسال الفتح (نبضة المرحّل)",
    opOn: "تم تشغيل المرحّل",
    opOff: "تم إيقاف المرحّل",
    opDone: "تم تنفيذ الإجراء",
    opFailed: "تعذّر تنفيذ الإجراء",
    opError: "خطأ أثناء تنفيذ الإجراء",
  },
};
